module.exports = "<div class=\"svc-creator-tab__content svc-embed-tab__content\">\n  <survey-widget params=\"model: survey\"></survey-widget>\n</div>";